import { FAQ } from 'components/more-info-page/faq/FAQ'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_FAQ } from 'services/apiFAQ'
import { Alert } from 'avo-ui'
import { convertErrorMessage } from 'utils/utils'

const INITIAL_STATE = {
    faqs: [
        {
            question: null,
            answer: null,
        },
    ],
}

const GET_FIELD_NAME = {
    faqs: 'FAQ item',
}

const GET_ITEM_FIELD_NAME = {
    question: 'Pertanyaan',
    answer: 'Jawaban',
}

export const FAQContainer = () => {
    const [reload, setReload] = useState(false)
    const [FAQDetail, setFAQDetail] = useState(INITIAL_STATE)
    const copyItems = [...(FAQDetail?.faqs || [])]
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getFAQDetail, isLoading } = useFetch(API_FAQ.DETAIL)
    const { fetching: updateFAQ, isLoading: isUpdating } = useFetch(API_FAQ.UPDATE)

    const setItems = (items) => {
        setFAQDetail({ faqs: items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                question: null,
                answer: null,
            },
        ])
    }

    const validateForm = () => {
        const validateFAQItems = () => {
            const result = []
            FAQDetail?.faqs?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.keys(FAQDetail).forEach((key) => {
                if (GET_FIELD_NAME[key] && FAQDetail[key]?.length === 0) {
                    errors[key] = `${GET_FIELD_NAME[key]} wajib diisi`
                } else if (GET_FIELD_NAME[key] && validateFAQItems()?.length) {
                    errors['faqs_detail'] = validateFAQItems()
                }
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            updateFAQ(FAQDetail)
                .then(() => {
                    setReload(!reload)
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'FAQ Updated !',
                    })
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, GET_ITEM_FIELD_NAME)))
        })
    }

    useEffect(() => {
        getFAQDetail().then((response) => setFAQDetail({ faqs: [...response?.data] }))
    }, [reload])

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        errorForm,
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <FAQ {...props} />
}
